<template>
  <div class="project-warpper">
    <div class="bg-white ">
      <div class="margin-bottom-sm flex align-center justify-between">
        <div class="flex align-center">
          <div class="flex align-center margin-right-sm">
            <span>社区：</span>
            <el-input v-model="searchName" placeholder="请输入社区" class="flex-sub"></el-input>
          </div>
          <div class="flex align-center margin-right-sm">
            <span>社区：</span>
            <el-input v-model="jingLiName" placeholder="请输入社区" class="flex-sub"></el-input>
          </div>
          <div class="flex align-center margin-right-sm">
            <span>状态：</span>
            <el-select v-model="status" placeholder="请选择状态" class="flex-sub">
              <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
        <el-button type="primary" @click="projectDialog = true">新增社区</el-button>
      </div>
      <el-table
          :data="projectList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          border
          style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号">
        </el-table-column>
        <el-table-column label="社区名称" prop="name"></el-table-column>
        <el-table-column label="社区负责人" prop="xiangmujingli_name"></el-table-column>
        <el-table-column label="联系电话" prop="xiangmujingli_phone"></el-table-column>
        <el-table-column label="创建时间" prop="create_time"></el-table-column>
        <el-table-column label="状态">

          <template slot-scope="scope">
            <div>
              {{ scope.row.status === 1 ? "正常" : "停用" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="beizhu"></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="small"
                  type="primary"
                  @click="editItem(scope.row)"
                  v-if="scope.row.status === 1"
              >编辑
              </el-button>
              <el-button
                  size="small"
                  type="primary"
                  @click="setLockItem(scope.row.id,2)"
                  v-if="scope.row.status === 1"
              >停用
              </el-button>
              <el-button
                  size="small"
                  type="success"
                  @click="setLockItem(scope.row.id,1)"
                  v-if="scope.row.status === 2"
              >启用
              </el-button>

<!--              <el-button-->
<!--                  size="small"-->
<!--                  type="primary"-->
<!--                  @click="deleteItem(scope.row.id)"-->
<!--              >删除-->
<!--              </el-button>-->
<!--              <router-link :to="'/manager?id=' + scope.row.id" class="margin-left-xs" target="_blank">-->
<!--                <el-button size="small" type="primary" >数据统计</el-button>-->
<!--              </router-link>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="projectList.length > 0"
          class="page-all"
          background
          @current-change="xiangMuList"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
    <projectDialog
        :setId="setId"
        :setItem="setItem"
        :projectDialog="projectDialog"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {xiangMudel, xiangMuList ,xiangMuUpdateStatus} from '@/api/project'
import projectDialog from "@/views/pages/dialog/prijectDialog";
import {powerTypes, zhDate} from "@/utils/utils";

export default {
  name: "project",
  data() {
    return {
      searchName: '',
      jingLiName: '',
      status: 0,
      statusList: [
        {value: 0, label: '全部'},
        {value: 1, label: '正常'},
        {value: 2, label: '停用'},
      ],
      page: 1,
      limit: 10,
      total: 0,
      projectList: [],
      setId: 0,
      setItem: {},
      projectDialog: false
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "系统管理 / 社区管理", false);
    this.xiangMuList()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {
    projectDialog
  },
  methods: {
    //  删除社区
    deleteItem(id) {
      this.$confirm('您确定要删除该社区吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await xiangMudel(id);
      if (this.projectList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.xiangMuList();
      this.$message.success(_state.info);
    },

    //  社区停用/启用
    setLockItem(id, state) {
      this.$confirm(state === 2 ? '您确定要停用该社区吗？' : '您确定要启用该社区吗', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureSetLock(id, state);
      });
    },
    async sureSetLock(id, state) {
      let _state = await xiangMuUpdateStatus(id, state);
      this.$message.success(_state.info);
      this.xiangMuList();

    },
    //  编辑
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.projectDialog = true;
    },
    //  员工信息编辑后回调
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.projectDialog = false;
        this.xiangMuList();
      } else {
        this.setId = 0;
        this.setItem = {};
        this.projectDialog = false;
      }
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.xiangMuList()
    },
    //  获取列表
    async xiangMuList() {
      let _list = await xiangMuList(this.searchName, this.jingLiName, this.status, this.page, this.limit)
      _list.data.map(item=>{
        item.create_time = zhDate(item.create_time*1000)
      })
      this.projectList = _list.data
      this.total = _list.total_number
    }
  },
  filters: {
    power(val) {
      return powerTypes(val)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
